/**
 * RESSONÂNCIA CURATIVA — DIAPASÃO 256Hz DARK LP
 * diapasao-dark.js v2
 * Fixes: oferta bidirecional, preços PIX corretos, visibilidade
 */

(function () {
  'use strict';

  /* 1. STICKY HEADER */
  function initStickyHeader() {
    var header = document.getElementById('dp-sticky-header');
    if (!header) return;
    var threshold = 300, ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          header.classList[window.scrollY > threshold ? 'add' : 'remove']('is-visible');
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* 2. VSL PLAYER */
  function initVSL() {
    var placeholder    = document.getElementById('dp-vsl-placeholder');
    var playBtn        = document.getElementById('dp-play-btn');
    var thumbnail      = placeholder && placeholder.querySelector('.dp-vsl__thumbnail');
    var videoContainer = document.getElementById('dp-video-container');
    var progressFill   = placeholder && placeholder.querySelector('.dp-vsl__progress-fill');
    if (!thumbnail || !videoContainer) return;

    function showVideo() {
      thumbnail.style.display = 'none';
      videoContainer.style.display = 'block';
      var iframe = videoContainer.querySelector('iframe');
      if (iframe) {
        var src = iframe.src;
        if (!src.includes('autoplay')) {
          iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
        }
      }
      if (progressFill) {
        var progress = 0;
        var interval = setInterval(function () {
          progress += 0.5;
          if (progress >= 100) { clearInterval(interval); return; }
          progressFill.style.width = progress + '%';
        }, 2400);
      }
      placeholder.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    thumbnail.addEventListener('click', showVideo);
    if (playBtn) playBtn.addEventListener('click', showVideo);
  }

  /* 3. COUNTDOWN */
  function initCountdown() {
    var hEl = document.getElementById('dp-h');
    var mEl = document.getElementById('dp-m');
    var sEl = document.getElementById('dp-s');
    if (!hEl || !mEl || !sEl) return;
    var KEY = 'dp_countdown_dark';
    var DURATION_MS = 52 * 60 * 1000;
    var now = Date.now();
    var stored = parseInt(localStorage.getItem(KEY), 10);
    var endTime = stored && stored > now ? stored : now + DURATION_MS;
    localStorage.setItem(KEY, endTime);
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = Math.max(0, endTime - Date.now());
      if (diff === 0) {
        endTime = Date.now() + DURATION_MS;
        localStorage.setItem(KEY, endTime);
      }
      hEl.textContent = pad(Math.floor(diff / 3600000));
      mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    setInterval(tick, 1000);
  }

  /* 4. VIEWER COUNT */
  function initViewerCount() {
    var el = document.getElementById('dp-viewer-count');
    if (!el) return;
    var base = 170 + Math.floor(Math.random() * 50);
    el.textContent = base;
    setInterval(function () {
      base += Math.floor(Math.random() * 7) - 3;
      base = Math.max(140, Math.min(280, base));
      el.textContent = base;
    }, 8000);
  }

  /* 5. FAQ ACCORDION */
  function initFAQ() {
    var list = document.getElementById('dp-faq-list');
    if (!list) return;
    var buttons = list.querySelectorAll('.dp-faq-item__q');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        buttons.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var a = b.nextElementSibling;
          if (a) a.classList.remove('is-open');
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          var ans = btn.nextElementSibling;
          if (ans) ans.classList.add('is-open');
        }
      });
    });
  }

  /* 6. OFFER SELECTOR + BUY BUTTON (bidirectional sync)
   *
   * Regras:
   * - Card "Kit Completo" selecionado  → bump marcado  → checkout: bundle
   * - Card "Só o Diapasão" selecionado → bump desmarcado → checkout: produto simples
   * - Marcar bump   → muda card para Kit
   * - Desmarcar bump → muda card para Básico
   */
  function initOfferAndBuy() {
    var cardBasic = document.getElementById('dp-offer-basic');
    var cardKit   = document.getElementById('dp-offer-kit');
    var bumpWrap  = document.getElementById('dp-order-bump');
    var bumpCheck = document.getElementById('dp-bump-check');
    var buyForm   = document.getElementById('dp-buy-form');
    var buyBtn    = document.getElementById('dp-buy-btn');
    var variantInput = document.getElementById('dp-selected-variant');

    // Price display elements
    var priceInt    = document.getElementById('dp-price-integer');
    var priceCts    = document.getElementById('dp-price-cents');
    var priceFromEl = document.getElementById('dp-price-from-val');
    var pricePixEl  = document.getElementById('dp-price-pix-main');
    var priceShipEl = document.getElementById('dp-price-shipping');
    var priceCardEl = document.getElementById('dp-price-card-info');
    var btnText     = document.getElementById('dp-btn-text');
    var mobileBar   = document.getElementById('dp-mobile-buy-bar');

    if (!cardBasic || !cardKit || !buyForm || !buyBtn) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root : '/';

    // Pricing config
    var OFFERS = {
      basic: {
        pix:         249.90,
        pixFmt:      'R$249,90',
        from:        'R$349,00',
        integer:     '249',
        cents:       ',90',
        shipping:    '+ Frete: R$30,00 mín.',
        card10x:     'No cartão: 10x de R$28,54 (2,49%/parcela)',
        btnLabel:    'GARANTIR MEU DIAPASÃO — R$249,90',
        mobilePrice: 'R$249,90 no PIX'
      },
      kit: {
        pix:         289.90,
        pixFmt:      'R$289,90',
        from:        'R$397,00',
        integer:     '289',
        cents:       ',90',
        shipping:    '+ Frete Grátis',
        card10x:     'No cartão: 10x de R$33,11 (2,49%/parcela)',
        btnLabel:    'GARANTIR MEU KIT — R$289,90',
        mobilePrice: 'R$289,90 no PIX'
      }
    };

    var currentOffer = buyForm.getAttribute('data-bundle-available') === 'true' ? 'kit' : 'basic';

    function getConfiguredId(offer) {
      return offer === 'kit'
        ? buyForm.getAttribute('data-bundle-id')
        : buyForm.getAttribute('data-main-id');
    }

    function getHandle(offer) {
      return offer === 'kit'
        ? buyForm.getAttribute('data-bundle-handle')
        : buyForm.getAttribute('data-main-handle');
    }

    function syncVariantInput() {
      if (!variantInput) return;
      variantInput.value = getConfiguredId(currentOffer) || '';
    }

    function applyOffer(offer) {
      // Não deixa a página apontar para um kit que o próprio Liquid já marcou
      // como indisponível. Se houver outra variante disponível, ela ainda será
      // encontrada dinamicamente no submit abaixo.
      if (offer === 'kit' && !getConfiguredId('kit') && !getHandle('kit')) {
        offer = 'basic';
      }

      currentOffer = offer;
      var o = OFFERS[offer];

      if (offer === 'kit') {
        cardKit.classList.add('is-active');
        cardKit.setAttribute('aria-checked', 'true');
        cardBasic.classList.remove('is-active');
        cardBasic.setAttribute('aria-checked', 'false');
        if (bumpCheck) bumpCheck.checked = true;
        if (bumpWrap)  { bumpWrap.classList.add('is-checked'); bumpWrap.style.display = ''; }
      } else {
        cardBasic.classList.add('is-active');
        cardBasic.setAttribute('aria-checked', 'true');
        cardKit.classList.remove('is-active');
        cardKit.setAttribute('aria-checked', 'false');
        if (bumpCheck) bumpCheck.checked = false;
        if (bumpWrap)  { bumpWrap.classList.remove('is-checked'); bumpWrap.style.display = ''; }
      }

      if (priceInt)    priceInt.textContent    = o.integer;
      if (priceCts)    priceCts.textContent    = o.cents;
      if (priceFromEl) priceFromEl.textContent = o.from;
      if (pricePixEl)  pricePixEl.innerHTML    = 'Valor no PIX: <strong>' + o.pixFmt + '</strong>';
      if (priceShipEl) priceShipEl.textContent = o.shipping;
      if (priceCardEl) priceCardEl.innerHTML   = o.card10x;
      if (btnText)     btnText.textContent     = o.btnLabel;

      if (mobileBar) {
        var mPrice = mobileBar.querySelector('span[data-price]');
        if (mPrice) mPrice.textContent = o.mobilePrice;
      }

      syncVariantInput();
    }

    // Resolve a variante vendável no momento do clique. Isto evita usar
    // variants.first quando a primeira variante está sem disponibilidade.
    function resolveAvailableVariant(offer, excludeId) {
      var configuredId = getConfiguredId(offer);
      var handle = getHandle(offer);

      if (!handle) {
        return configuredId
          ? Promise.resolve(String(configuredId))
          : Promise.reject(new Error('Produto não configurado para esta oferta.'));
      }

      var productUrl = root + 'products/' + encodeURIComponent(handle) + '.js';
      return fetch(productUrl, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('O produto "' + handle + '" não está disponível no canal Loja virtual.');
        }
        return response.json();
      })
      .then(function (productData) {
        var variants = (productData && productData.variants) || [];
        var chosen = null;

        // 1) Mantém a variante escolhida no Liquid se ela continua disponível.
        if (configuredId) {
          chosen = variants.find(function (v) {
            return String(v.id) === String(configuredId) && v.available && String(v.id) !== String(excludeId || '');
          });
        }

        // 2) Caso contrário, usa a primeira variante realmente disponível.
        if (!chosen) {
          chosen = variants.find(function (v) {
            return v.available && String(v.id) !== String(excludeId || '');
          });
        }

        if (!chosen) {
          var label = offer === 'kit' ? 'Kit Completo' : 'Diapasão';
          throw new Error(label + ' sem variante disponível para compra no momento.');
        }

        return String(chosen.id);
      });
    }

    function clearCart() {
      return fetch(root + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin'
      }).catch(function () {
        // Não bloqueia a compra se a limpeza do carrinho falhar.
        return null;
      });
    }

    function addVariant(id) {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: String(id), quantity: 1 }] })
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) {
            var err = new Error(data.description || data.message || ('HTTP ' + response.status));
            err.status = response.status;
            err.payload = data;
            throw err;
          }
          return data;
        });
      });
    }

    function looksLikeInventoryError(err) {
      var msg = String(err && err.message || '').toLowerCase();
      return err && err.status === 422 && (
        msg.indexOf('sold out') !== -1 ||
        msg.indexOf('inventory') !== -1 ||
        msg.indexOf('quantity') !== -1 ||
        msg.indexOf('estoque') !== -1 ||
        msg.indexOf('esgot') !== -1 ||
        msg.indexOf('available') !== -1 ||
        msg.indexOf('dispon') !== -1
      );
    }

    // Card clicks
    cardBasic.addEventListener('click', function () { applyOffer('basic'); });
    cardKit.addEventListener('click',   function () { applyOffer('kit');   });

    [cardBasic, cardKit].forEach(function (card) {
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
      });
    });

    if (bumpCheck) {
      bumpCheck.addEventListener('change', function () {
        applyOffer(bumpCheck.checked ? 'kit' : 'basic');
      });
    }

    applyOffer(currentOffer);

    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var textEl = buyBtn.querySelector('.dp-btn-buy__text') || buyBtn;
      var originalText = textEl.textContent;
      textEl.textContent = 'A processar...';
      buyBtn.classList.add('is-loading');
      buyBtn.disabled = true;

      function restoreButton() {
        textEl.textContent = originalText;
        buyBtn.classList.remove('is-loading');
        buyBtn.disabled = false;
      }

      function fail(err) {
        if (window.console) console.error('[dp] erro ao iniciar compra:', err);
        var msg = err && err.message ? err.message : 'Erro inesperado.';
        alert('Não foi possível iniciar a compra. ' + msg + '\nTente novamente ou fale com a gente.');
        restoreButton();
      }

      var resolvedId = null;

      resolveAvailableVariant(currentOffer)
        .then(function (id) {
          resolvedId = id;
          if (variantInput) variantInput.value = id;
          return clearCart();
        })
        .then(function () {
          return addVariant(resolvedId);
        })
        .catch(function (err) {
          // Se o estoque mudou entre renderização e clique, atualiza o produto e
          // tenta UMA vez com outra variante disponível. Não repete a mesma ID.
          if (!looksLikeInventoryError(err) || !resolvedId) throw err;
          return resolveAvailableVariant(currentOffer, resolvedId)
            .then(function (retryId) {
              resolvedId = retryId;
              if (variantInput) variantInput.value = retryId;
              return clearCart().then(function () { return addVariant(retryId); });
            });
        })
        .then(function () {
          window.location.href = root + 'checkout';
        })
        .catch(fail);
    });
  }

  /* 7. SCROLL REVEAL */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll(
      '.dp-symptom-card, .dp-testimonial-card, .dp-compare__col, ' +
      '.dp-howto__step, .dp-testimonial-featured, .dp-guarantee__card'
    );
    targets.forEach(function (el, i) {
      el.style.opacity   = '0';
      el.style.transform = 'translateY(22px)';
      el.style.transition = 'opacity 0.5s ease ' + (i % 4) * 0.08 + 's, transform 0.5s ease ' + (i % 4) * 0.08 + 's';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity   = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* 8. SOCIAL PROOF POPUP */
  function initSocialProofPopup() {
    var proofs = [
      { name: 'Beatriz H.', city: 'SP', action: 'acabou de comprar', icon: '🛒' },
      { name: 'Roberto M.', city: 'MG', action: 'adicionou ao carrinho', icon: '🛒' },
      { name: 'Cláudio S.', city: 'PR', action: 'acabou de comprar + guia', icon: '✓' },
      { name: 'Patricia L.', city: 'RS', action: 'está comprando agora', icon: '⚡' },
      { name: 'Fernanda A.', city: 'SC', action: 'acabou de comprar', icon: '🛒' },
      { name: 'Marcos C.',   city: 'RJ', action: 'está vendo esta página', icon: '👁' },
    ];
    var idx = 0;
    var popup = document.createElement('div');
    popup.id = 'dp-sp-popup';
    popup.style.cssText = 'position:fixed;bottom:24px;left:20px;background:#1C1008;border-radius:10px;padding:14px 16px;box-shadow:0 8px 32px rgba(0,0,0,0.5);max-width:300px;z-index:9999;font-family:Lato,sans-serif;border-left:4px solid #8B4513;border:1px solid rgba(250,247,242,0.10);border-left:4px solid #8B4513;display:none;transition:opacity 0.3s;';
    document.head.insertAdjacentHTML('beforeend',
      '<style>@keyframes dpDarkSlide{from{opacity:0;transform:translateX(-18px)}to{opacity:1;transform:translateX(0)}}</style>'
    );
    document.body.appendChild(popup);

    function show() {
      var p = proofs[idx % proofs.length];
      popup.innerHTML = [
        '<div style="display:flex;align-items:center;gap:10px">',
          '<div style="width:34px;height:34px;border-radius:50%;background:#8B4513;color:#FAF7F2;display:flex;align-items:center;justify-content:center;font-size:14px;flex-shrink:0">' + p.name[0] + '</div>',
          '<div style="flex:1">',
            '<div style="font-size:12px;font-weight:700;color:#FAF7F2">' + p.name + ' · ' + p.city + '</div>',
            '<div style="font-size:12px;color:rgba(250,247,242,0.65)">' + p.icon + ' ' + p.action + '</div>',
            '<div style="font-size:11px;color:#D4A017;margin-top:2px">Ressonância Curativa 256Hz</div>',
          '</div>',
          '<button onclick="this.parentElement.parentElement.style.display=\'none\'" style="background:none;border:none;cursor:pointer;color:rgba(250,247,242,0.30);font-size:18px;padding:0;line-height:1;flex-shrink:0">×</button>',
        '</div>',
      ].join('');
      popup.style.display = 'block';
      popup.style.animation = 'dpDarkSlide 0.4s ease';
      setTimeout(function () {
        popup.style.opacity = '0';
        setTimeout(function () { popup.style.display = 'none'; popup.style.opacity = '1'; }, 350);
      }, 5000);
      idx++;
    }
    setTimeout(function () { show(); setInterval(show, 28000); }, 12000);
  }

  /* ══════════════════════════════════════════════
      9. STICKY BUY BAR — mobile only
   ══════════════════════════════════════════════ */
function initMobileStickyBuy() {
  // Mantém a regra de só aparecer no mobile
  if (window.innerWidth > 768) return;
  var buySection = document.getElementById('dp-buy-section');
  if (!buySection) return;

  var bar = document.createElement('div');
  bar.id = 'dp-mobile-buy-bar';
  bar.innerHTML = [
    '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px">', // Gap mínimo para evitar empurrões
      
      // COLUNA DA ESQUERDA (Diapasão + Garantia)
      '<div style="text-align:left;line-height:1.5;flex-grow:1;">',
        '<div style="font-family:\'Lato\',sans;font-size:15px;font-weight:700;color:#FAF7F2;letter-spacing:0.04em;display:block">Diapasão</div>',
        '<div style="font-family:\'Lato\',sans;font-size:15px;font-weight:700;color:#FAF7F2;letter-spacing:0.04em;margin-bottom:2px">256Hz</div>',
        '<div style="font-size:10px;color:rgba(250,247,242,0.6)">Garantia 30 dias</div>',
      '</div>',
      
      // COLUNA CENTRAL (Estoque Limitado)
      '<div style="text-align:center;line-height:1.5;padding:0 8px;flex-grow:0;flex-shrink:0;">',
        '<div style="font-size:15px;font-weight:700;color:#D8A561;letter-spacing:0.02em;white-space:nowrap">Estoque</div>', // Cor dourada similar à imagem
        '<div style="font-size:15px;font-weight:700;color:#D8A561;letter-spacing:0.02em;white-space:nowrap">Limitado</div>', // Cor dourada similar à imagem
      '</div>',
      
      // COLUNA DA DIREITA (Botão CTA)
      '<div style="flex-grow:0;flex-shrink:0;">',
        '<a href="#dp-buy-section" id="dp-mobile-cta" style="background:#8B4513;color:#FAF7F2;text-decoration:none;border-radius:8px;padding:10px 14px;font-size:15px;font-weight:700;letter-spacing:0.02em;white-space:nowrap;display:inline-block">Confira a Disponibilidade</a>',
      '</div>',
    '</div>',
  ].join('');
  
  // Estilos da barra externa (fundo e borda superior)
  bar.style.cssText = [
    'position:fixed', 'bottom:0', 'left:0', 'right:0',
    'background:#1A0F0A', 'padding:15px 15px', 'z-index:199', // Fundo mais escuro, padding lateral
    'border-top:2px solid #8B4513', 'box-shadow:0 -4px 20px rgba(0,0,0,0.3)',
    'transform:translateY(100%)', 'transition:transform 0.35s cubic-bezier(.4,0,.2,1)',
    'display:none',
  ].join(';');

  document.body.appendChild(bar);
  bar.style.display = 'block';

  // Lógica do IntersectionObserver (mantida)
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.style.transform = entry.isIntersecting
        ? 'translateY(100%)'
        : 'translateY(0)';
    });
  }, { threshold: 0 });

  io.observe(buySection);
}

  /* 10. SMOOTH SCROLL */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - 70;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* 11. WAVE ANIMATION */
  function initWaveAnimation() {
    var svg = document.querySelector('.dp-science__wave-svg');
    if (!svg) return;
    svg.querySelectorAll('path').forEach(function (path, i) {
      path.style.animation = 'dpWave ' + (2.5 + i * 0.5) + 's ease-in-out infinite ' + (i * 0.3) + 's';
    });
    document.head.insertAdjacentHTML('beforeend',
      '<style>@keyframes dpWave{0%,100%{opacity:0.3}50%{opacity:1}}</style>'
    );
  }

  /* 12. SCROLL TRACKING */
  function initScrollTracking() {
    var sections = {
      'dp-buy-section': 'ViewContent_BuySection',
      'dp-vsl-wrap':    'ViewContent_VSL',
    };
    if (!('IntersectionObserver' in window)) return;
    Object.keys(sections).forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var fired = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !fired) {
            fired = true;
            if (typeof fbq === 'function') fbq('trackCustom', sections[id]);
            if (typeof gtag === 'function') gtag('event', sections[id]);
          }
        });
      }, { threshold: 0.3 });
      io.observe(el);
    });
  }

  /* INIT */
  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initVSL();
    initCountdown();
    initViewerCount();
    initFAQ();
    initOfferAndBuy();
    initScrollReveal();
    initSocialProofPopup();
    initMobileStickyBuy();
    initSmoothScroll();
    initWaveAnimation();
    initScrollTracking();
  });

})();
